import { EPPAStep } from 'types/ppaOnboarding';

export const Step1End = EPPAStep.STEP_4;
export const Step2End = EPPAStep.STEP_8;
export const Step3End = EPPAStep.STEP_13;
export const Step4End = EPPAStep.STEP_18;

export const createStep = [EPPAStep.STEP_1, EPPAStep.STEP_2, EPPAStep.STEP_3, EPPAStep.STEP_4];
export const serviceStep = [EPPAStep.STEP_5, EPPAStep.STEP_6, EPPAStep.STEP_7, EPPAStep.STEP_8];
export const listOnKlarityStep = [EPPAStep.STEP_9, EPPAStep.STEP_10, EPPAStep.STEP_11, EPPAStep.STEP_12, EPPAStep.STEP_13];
export const configureAvailabilityStep = [EPPAStep.STEP_14, EPPAStep.STEP_15, EPPAStep.STEP_16, EPPAStep.STEP_17, EPPAStep.STEP_17_1, EPPAStep.STEP_18];

// 按照 EPPAStep 枚举定义的顺序排列所有步骤
const allStepsInOrder: EPPAStep[] = [
    EPPAStep.STEP_1,
    EPPAStep.STEP_2,
    EPPAStep.STEP_3,
    EPPAStep.STEP_4,
    EPPAStep.STEP_5,
    EPPAStep.STEP_6,
    EPPAStep.STEP_7,
    EPPAStep.STEP_8,
    EPPAStep.STEP_9,
    EPPAStep.STEP_10,
    EPPAStep.STEP_11,
    EPPAStep.STEP_12,
    EPPAStep.STEP_13,
    EPPAStep.STEP_14,
    EPPAStep.STEP_15,
    EPPAStep.STEP_16,
    EPPAStep.STEP_17,
    EPPAStep.STEP_17_1,
    EPPAStep.STEP_18,
    EPPAStep.STEP_19,
    EPPAStep.STEP_20,
    EPPAStep.STEP_21,
];

/**
 * 根据 EPPAStep 枚举顺序返回下一个步骤
 * @param step 当前步骤
 * @returns 下一个步骤，如果已经是最后一步则返回当前步骤
 */
export const getNextStep = (step: EPPAStep): EPPAStep => {
    const currentIndex = allStepsInOrder.indexOf(step);
    if (currentIndex === -1 || currentIndex === allStepsInOrder.length - 1) {
        // 如果找不到当前步骤或已经是最后一步，返回当前步骤
        return step;
    }
    return allStepsInOrder[currentIndex + 1];
};

/**
 * 根据 EPPAStep 枚举顺序返回上一个步骤
 * @param step 当前步骤
 * @returns 上一个步骤，如果已经是第一步则返回当前步骤
 */
export const getPrevStep = (step: EPPAStep): EPPAStep => {
    const currentIndex = allStepsInOrder.indexOf(step);
    if (currentIndex === -1 || currentIndex === 0) {
        // 如果找不到当前步骤或已经是第一步，返回当前步骤
        return step;
    }
    return allStepsInOrder[currentIndex - 1];
};

export const getCurrentStepNumber = (step?: EPPAStep) => {
    if (!step) return 1;
    const [, currentStep] = step.split('_');
    return Number(currentStep);
};

export const generateStepByNumber = (stepNumber: number, step: EPPAStep) => {
    const [prefix, mainStep] = step.split('_');
    return `${prefix}_${mainStep}_${stepNumber}` as EPPAStep;
};
